
import { isPRS } from '../../actions/root_url';

function filterPermissions(permission) {
  switch (permission) {
    case "add_purchase_order":
    case "view_purchase_order":
    case "view_purchase_return":
    case "view_purchase_performance":
    case "view_price_reference":
    case "view_purchase_reference":
    case "view_inventory_transfer":
    case "view_receive":
    case "view_receive_history":
    case "view_shelf_life_statistics":
    case "view_routing":
    case "view_edit_route":
    case "view_shipping":
    case "view_routing":
    case "view_account_payable":
    case "view_payment_summary":
    case "view_purchase_payment":
    case "view_sales_report":
    case "view_general_report":
    case "view_vendor_statement":
    case "view_city_report":
      return false;
    default:
      return true;
  }
}
export default function checkPermission(permission) {
  const userPermissions = JSON.parse(localStorage.getItem('userPermissions')) || [];
  let isPermission = false;
  if (isPRS && !filterPermissions(permission)) {
    return false;
  }
  if (userPermissions.length) {
    userPermissions.map((p) => {
      if (p.codename === permission) {
        isPermission = true;
      }
    });
  }
  return isPermission;
}
/*
These are all the permissions for each page

Purchase Management
  Prepare Order (smilinghome only)
    view_prepare_order
    add_prepare_order
    change_prepare_order
    delete_prepare_order
    print_prepare_order
    
  Purchase Order
      view_purchase_order
      add_purchase_order
      change_purchase_order
      delete_purchase_order
      print_purchase_order

  Purchase Return
      view_purchase_return
      add_purchase_return
      change_purchase_return
      delete_purchase_return
      print_purchase_return

  Purchase Performance
      view_purchase_performance
      print_purchase_performance

  Price Reference
      view_price_reference
      change_price_reference

  Purchase Reference
      view_purchase_reference
      print_purchase_reference

Sales Management
  Sales Order
      view_sales_order
      add_sales_order
      change_sales_order
      delete_sales_order
      print_sales_order

  Mobile Sales Order
      view_mobile_order
      add_mobile_order
      change_mobile_order
      delete_mobile_order (delete_sales_order)
      print_mobile_order

  Sales Invoice
      view_sales_invoice
      add_sales_invoice
      change_sales_invoice
      delete_sales_invoice
      print_sales_invoice
      edit_finalize_sales_invoice
      edit_customer_sales_invoice

  Promotions
      view_promotions
      add_promotions
      change_promotions
      delete_promotions
      print_promotions

  Favorites List
      view_sales_favorites
      add_sales_favorites
      change_sales_favorites
      delete_sales_favorites
      print_sales_favorites

  Sales Performance
      view_sales_performance
      print_sales_performance

Warehouse Management
  Inventory
      view_inventory
      change_inventory

  New Receiving
      view_receive
      add_receive
      print_receive

  Receiving
      view_receive_history
      change_receive
      delete_receive

  Inventory Repackage
      view_repackage
      add_warehouse_repackage
      change_warehouse_repackage


  Inventory Relocation
      view_inventory_relocation
      change_warehouse_relocation
      delete_warehouse_relocation

  Inventory Adjustment
      view_inventory_adjustment
      change_warehouse_adjustment
      delete_warehouse_adjustment

  Scrap Records
      view_warehouse_scrap
      add_warehouse_scrap
      change_warehouse_scrap

  Outbound
      view_sales_order //Not a working tab

  Warehouse
      view_warehouse
      add_warehouse
      change_warehouse
      change_receiving_history_quantity_price

  Product Convert
      view_product_convert
      add_product_convert

Dispatch
  Routing
      view_routing

  Edit Routes
      view_edit_route

  Shipping
      view_shipping

AR/AP
  Accounts Receivable
      view_account_receivable
      add_account_receivable
      change_account_receivable
      delete_account_receivable
      print_account_receivable

  Accounts Payable
      view_account_payable
      add_account_payable
      change_account_payable
      delete_account_payable
      print_account_payable

  Purchase Report
      view_purchase_payment
      change_purchase_payment

  Sales Invoice (AR Sales Invoice)
      view_sales_invoice
      add_sales_invoice
      change_sales_invoice
      delete_sales_invoice
      print_sales_invoice
      edit_finalize_sales_invoice

  Sales Report
      view_sales_report

  General Report
      view_general_report
      print_general_report

  AR Aged Report
      view_customer_statement
      print_customer_statement

  AP Aged Report
      view_vendor_statement
      print_vendor_statement

  Customer Statement
      view_customer_statement
      print_customer_statement

  Vendor Statement
      view_vendor_statement
      print_vendor_statement

  City Report
      view_city_report
      print_city_report

  Mobile Customer Statement
      view_customer_statement
      print_customer_statement

Returns
  New Sales Return
      view_sales_return
      add_sales_return

  Sales Return
      change_sales_return
      delete_sales_return

POS Management
  POS
      view_pos

  POS Report
      view_pos

  POS Order
      view_pos
      add_void_order

General Management
  Product
      view_product
      add_product
      change_product
      change_shipping_misc

  Customer
      view_customer
      change_customer
      add_customer

  Vendor
      view_vendor
      add_vendor
      change_vendor

  Payment Term
      view_payment_term
      add_payment_term
      change_payment_term

  Groups Management
    Group / Pkg Type / MM Type
      view_product_group
      add_product_group
      change_product_group
      delete_product_group

    Category / Category 2
      view_product_category
      add_product_category
      change_product_category
      delete_product_category

  Price Level
      view_price_level
      change_price_level

  President Dashboard
      view_dashboard_president
      view_category_analysis

Admin Tools
  User Management
      view_baseuser
      add_baseuser
      change_baseuser

  Role Management
      view_group
      add_group
      change_group

  Tax Management
      view_tax_area
      add_tax_area
      change_tax_area
      delete_tax_area

  Currency Management
      view_currency
      change_currency

  RMA
      view_bd_rma_customer
      change_bd_rma_customer
      add_bd_rma_customer
      view_bd_rma
      change_bd_rma
*/



// WEBPACK FOOTER //
// ./master/jsx/components/Common/permissions.jsx